// Single source of truth for the property's official social / marketplace
// profile links. Every surface that shows these links — the site footer, the
// contact page, the media kit, and the Organization JSON-LD `sameAs` array —
// reads from here so they can never drift apart.
//
// To add a profile, fill in its `url`. Profiles without a `url` are simply
// omitted everywhere (no dead or placeholder links are ever rendered).
//
// NOTE: the static JSON-LD `sameAs` in `index.html` is a JS-free crawler
// fallback and must be kept in sync with this list by hand.

export type SocialPlatform =
  | "airbnb"
  | "vrbo"
  | "facebook"
  | "instagram"
  | "tiktok"
  | "pinterest"
  | "google"
  | "yelp";

export interface SocialProfile {
  platform: SocialPlatform;
  /** Accessible label, e.g. "Legendary Log Cabin on Airbnb". */
  label: string;
  /** Public profile URL. Leave undefined to omit the profile everywhere. */
  url?: string;
}

const PROFILES: SocialProfile[] = [
  {
    platform: "airbnb",
    label: "Legendary Log Cabin on Airbnb",
    url: "https://www.airbnb.com/rooms/937046115859272290",
  },
  { platform: "vrbo", label: "Legendary Log Cabin on Vrbo", url: "https://www.vrbo.com/it-it/affitto-vacanze/p3721185vb" },
  {
    platform: "facebook",
    label: "Legendary Log Cabin on Facebook",
    url: "https://www.facebook.com/profile.php?id=61554642060815",
  },
  {
    platform: "instagram",
    label: "Legendary Log Cabin on Instagram",
    url: "https://www.instagram.com/p/DLNO-VtOGmD/",
  },
  {
    platform: "tiktok",
    label: "Legendary Log Cabin on TikTok",
    url: "https://www.tiktok.com/@legendarylogcabin",
  },
  { platform: "pinterest", label: "Legendary Log Cabin on Pinterest" },
  { platform: "google", label: "Legendary Log Cabin on Google Business Profile" },
  { platform: "yelp", label: "Legendary Log Cabin on Yelp" },
];

/** Profiles that have a real URL, in display order. */
export const socialProfiles: Array<Required<SocialProfile>> = PROFILES.filter(
  (p): p is Required<SocialProfile> => Boolean(p.url),
);

/** URLs for the Organization JSON-LD `sameAs` array. */
export const sameAsUrls: string[] = socialProfiles.map((p) => p.url);
